import { pidOf, currentClientId } from '../../utils/normalizePlayerId';

export function computeReadyInfo(gameRoomData, socket, user) {
  const gameRoomPlayers = gameRoomData?.gameRoomPlayers || [];
  const gameRoomSpectators = gameRoomData?.gameRoomSpectators || [];
  const gameRoomGame = gameRoomData?.gameRoomGame || {};
  const minPlayers = typeof gameRoomData?.gameRoomConfigSchema?.minPlayers === 'number'
    ? gameRoomData.gameRoomConfigSchema.minPlayers
    : 2;
  const hostUserId = gameRoomData?.gameRoomDetails?.hostUserId || "";
  const hostSocketId = gameRoomData?.gameRoomDetails?.hostSocketId || "";

  const readyPlayers = Array.isArray(gameRoomGame.readyPlayers) ? gameRoomGame.readyPlayers : [];

  const isHost = !!(
    socket && (
      (socket.auth && socket.auth.userId === hostUserId) ||
      socket.id === hostSocketId
    )
  );

  const isSpectator = Array.isArray(gameRoomSpectators)
    ? gameRoomSpectators.some((s) => s.socketId === socket?.id || s.userId === user?.userId)
    : false;

  const nonHostPlayers = (Array.isArray(gameRoomPlayers) ? gameRoomPlayers : []).filter((p) => {
    if (p.isHost) return false;
    if (p.socketId && p.socketId === hostSocketId) return false;
    if (p.userId && p.userId === hostUserId) return false;
    return true;
  });

  // Treat readyPlayers as an array of persistent userIds where possible.
  const readyCount = readyPlayers.filter((id) =>
    nonHostPlayers.some((p) => pidOf(p) === id)
  ).length;

  const canHostStartSolo = minPlayers <= 1 && nonHostPlayers.length === 0;
  const allReady = canHostStartSolo || (nonHostPlayers.length > 0 && readyCount === nonHostPlayers.length);
  const currentUser = currentClientId(socket, user);
  const isReady = currentUser ? readyPlayers.includes(currentUser) : false;

  return {
    gameRoomPlayers,
    gameRoomSpectators,
    gameRoomGame,
    hostUserId,
    hostSocketId,
    readyPlayers,
    minPlayers,
    nonHostPlayers,
    readyCount,
    allReady,
    canHostStartSolo,
    isReady,
    isHost,
    isSpectator,
  };
}

export default computeReadyInfo;
